
export const InventoryItemCondition = {
  new: 'New',
  used: 'Used',
  demo: 'Demo',
};

export class QuoteInventoryItemViewModel {
  constructor(item) {
    this.id = item.id;
    this.name = item.name;
    this.productId = item.productId;
    this.productGroupId = item.productGroupId;
    this.inStock = item.inStock;
    this.leadTime = new QuoteInventoryItemLeadTimeViewModel(item.leadTime);
    this.quantity = item.quantity;
    this.productOptions = item.productOptions.map((x) => new QuoteInventoryItemOptionViewModel(x));
    this.notes = item.notes;
    this.paintColor = item.paintColor;
    this.isRestricted = item.isRestricted;
    this.restrictedReason = item.restrictedReason;
    this.isConsignment = item.isConsignment;
    this.consignmentDealerBranchId = item.consignmentDealerBranchId;
    this.consignmentDealerBranchName = item.consignmentDealerBranchName;
    this.defaultTerritoryManagerName = item.defaultTerritoryManagerName;
    this.sold = item.sold;
    this.condition = item.condition;
    this.minimumLeadTime = item.minimumLeadTime;

    this.carrierId = item.carrierId;
    this.carrierName = item.carrierName;
    this.weightCategoryIds = item.weightCategoryIds;
    this.weightCategoryLabels = item.weightCategoryLabels;
    this.lugging = item.lugging != null && item.lugging !== undefined ? new QuoteInventoryItemLuggingViewModel(item.lugging) : null;
    this.thumb = item.thumb !== null && item.thumb !== undefined ? new QuoteInventoryItemThumbViewModel(item.thumb) : null;
    this.attachmentPointId = item.attachmentPointId;
    this.availableOn = item.availableOn;

    // UI Only
    this.incompatible = false;
    this.isAddedToQuote = false;
  }
}

export class QuoteInventoryItemLeadTimeViewModel {
  constructor(json) {
    this.numberOfDays = json.numberOfDays;
    this.minimumNumberOfDays = json.minimumNumberOfDays;
    this.availableOn = json.availableOn;
    this.inStock = json.inStock;
    this.type = json.type;
  }
}

export class QuoteInventoryItemOptionViewModel {
  constructor(json) {
    this.productOptionSetId = json.productOptionSetId;
    this.productOptionId = json.productOptionId;
    this.name = json.name;
    this.partNumber = json.partNumber;
    this.seriesName = json.seriesName;
  }
}

export class QuoteInventoryItemLuggingViewModel {
  constructor(json) {
    this.pinUpName = json.pinUpName;
    this.couplerPartNumber = json.couplerPartNumber;
    this.pinUpPartNumber = json.pinUpPartNumber;
    this.couplerNames = json.couplerNames;
  }
}

export class QuoteInventoryItemThumbViewModel {
  constructor(json) {
    this.factoryMount = json.factoryMount;
    this.tipRadius = json.tipRadius;
    this.thumbClassPartNumber = json.thumbClassPartNumber;
  }
}
